<div class="groups-menu-link {{group.customClass}}" *ngFor="let group of groups">
  <a *ngIf="!group.isOpen && group.links" [routerLink]="group.link"
    (click)="handleLinkNavigator(group.externalLink, group.action)" [queryParams]="group.queryParams"
    (click)="loadSubGroups(group)" routerLinkActive>
    <span class="span-container">
      <sp-icon class="menu-group-link-icon" *ngIf="group.icon && group.icon !== ''" [name]="group.icon" type="solid"
        size="small"></sp-icon>
      <span class="span-contain-icon">
        <label *ngIf="group.count" class="counter">{{ group.count }}</label>
        <div class="group-direction">
          <span>{{ group.title }} </span>
          <span class="group-subtitle"> {{group.subTitle ? group.subTitle : ''}}</span>
        </div>
        <img class="menu-group-link-icon-toggle" src="/public/resources/images/icons/icon-forward.svg" />
      </span>
    </span>
  </a>
  <a *ngIf="group.isOpen && group.links" routerLinkActive [routerLink]="group.link" [queryParams]="group.queryParams"
    (click)="shrinkGroup(group)">
    <span class="span-container">
      <sp-icon class="menu-group-link-icon" *ngIf="group.icon && group.icon !== ''" [name]="group.icon" type="solid"
        size="small"></sp-icon>
      <span class="span-contain-icon">
        <label *ngIf="group.count" class="counter">{{ group.count }}</label>
        <div class="group-direction">
          <span>{{ group.title }} </span>
          <span class="group-subtitle"> {{group.subTitle ? group.subTitle : ''}}</span>
        </div>
        <img class="menu-group-link-icon-toggle up" src="/public/resources/images/icons/icon-forward.svg" />
      </span>
    </span>
  </a>
  <div *ngIf="group['isOpen']" [class.--open]="group['isOpen']">
    <sp-menu-v2 [groups]="loadSubGroups(group)" (click)="hideMenu($event)"></sp-menu-v2>
  </div>
  <a routerLinkActive #rla="routerLinkActive"
    [ngClass]="{ active: rla.isActive && !group.externalLink && !group.action }" *ngIf="!group.links"
    [routerLink]="group.link" [queryParams]="group.queryParams" (click)="hideMenu($event)">
    <span class="span-container">
      <sp-icon class="menu-group-link-icon" *ngIf="group.icon && group.icon !== ''" [name]="group.icon" type="solid"
        size="small"></sp-icon>
      <label *ngIf="group.count" class="counter">{{ group.count }}</label>
      <span class="group-title">{{ group.title }} <span class="group-subtitle">{{group.subTitle ? group.subTitle :
          ''}}</span>
      </span>
    </span>
  </a>
</div>